import React from "react"
import { Link } from "react-router-dom" // Use Link if using React Router

function Header() {
  const language = process.env.REACT_APP_LANGUAGE || "en"
  const [isMenuOpen, setIsMenuOpen] = React.useState(false)

  const text = {
    en: {
      wallet: "Wallet",
      pointsSearch: "Points Search",
      about: "About",
    },
    zh: {
      wallet: "钱包",
      pointsSearch: "积分搜索",
      about: "关于",
    },
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header className="bg-white shadow-md relative">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        {/* Brand Name */}
        <div className="flex items-center align-middle space-x-4">
          <Link to="/">
            <span className="text-xl sm:text-2xl font-extrabold text-green-600">
              Smart
            </span>
            <span className="text-xl sm:text-2xl font-extrabold text-yellow-500 mx-1">
              Wallet
            </span>
            <span className="text-xl sm:text-2xl font-extrabold text-blue-600">
              Picks
            </span>
          </Link>
          <ion-icon
            name="wallet-outline"
            style={{
              fontSize: "1.5rem",
              color: "rgb(82, 90, 85)",
            }}
          ></ion-icon>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6">
          <Link
            to="/wallet"
            className="text-gray-600 hover:text-blue-500 font-medium transition duration-200"
          >
            {text[language].wallet}
          </Link>
          <Link
            to="/points-search"
            className="text-gray-600 hover:text-blue-500 font-medium transition duration-200"
          >
            {text[language].pointsSearch}
          </Link>
          <Link
            to="/aboutus"
            className="text-gray-600 hover:text-blue-500 font-medium transition duration-200"
          >
            {text[language].about}
          </Link>
          {language === "zh" ? (
            <Link
              to="https://smartwalletpicks.com/"
              className="text-gray-600 hover:text-blue-500 font-medium transition duration-200"
            >
              English
            </Link>
          ) : (
            <></>
          )}
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-gray-600 focus:outline-none"
          onClick={toggleMenu}
        >
          <ion-icon
            name={isMenuOpen ? "close-outline" : "menu-outline"}
            style={{ fontSize: "2rem" }}
          ></ion-icon>
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="md:hidden bg-white shadow-lg absolute top-full left-0 w-full z-10">
          <nav className="flex flex-col px-6 py-4 space-y-4">
            <Link
              to="/wallet"
              className="text-gray-600 hover:text-blue-500 font-medium transition duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              {text[language].wallet}
            </Link>
            <Link
              to="/points-search"
              className="text-gray-600 hover:text-blue-500 font-medium transition duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              {text[language].pointsSearch}
            </Link>
            <Link
              to="/aboutus"
              className="text-gray-600 hover:text-blue-500 font-medium transition duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              {text[language].about}
            </Link>
            {language === "zh" && (
              <Link
                to="https://smartwalletpicks.com/"
                className="text-gray-600 hover:text-blue-500 font-medium transition duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                English
              </Link>
            )}
          </nav>
        </div>
      )}
    </header>
  )
}

export default Header
